import type { ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import { Card } from "./Card";
import {
  fonts,
  letterSpacing,
  textRoles,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function MetricCard({
  label,
  value,
  hint,
  accent = "none",
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  accent?: "none" | "mint" | "danger";
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <Card gap="xs" compact accent={accent}>
      <Text style={stylesheet.label}>{label}</Text>
      <Text style={stylesheet.value}>{value}</Text>
      {hint ? <Text style={stylesheet.hint}>{hint}</Text> : null}
    </Card>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    label: {
      color: colors.mutedForeground,
      fontFamily: fonts.semibold,
      fontSize: textRoles.eyebrow,
      letterSpacing: letterSpacing.eyebrow,
      textTransform: "uppercase",
    },
    value: {
      color: colors.heading,
      fontFamily: fonts.bold,
      fontSize: 22,
      fontVariant: ["tabular-nums"],
      letterSpacing: -0.3,
    },
    hint: {
      color: colors.mutedForeground,
      fontFamily: fonts.regular,
      fontSize: textRoles.eyebrow,
    },
  });
